export default "__VITE_ASSET__U_TvE1N6__"